module.exports = __webpack_public_path__ + "img/H01116-70.c5f8fd71.jpg";